import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';
import useGetCostCenterSortorder from './hooks/useGetCostCenterSortorder';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';
import { useGetColumns } from './hooks/useGetColumns';
import { ControlledDatePicker } from 'components/shared/ControlledFields';
import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import { referenceDateSchema } from 'components/admin-portal/Procedures/Reports/CollectedReports/schema';

const FormationAndSortorder = ({ costCenterId, date }) => {
  const initialDate = dayjs(date).startOf('day').toISOString();
  const { t } = useTranslation('common');
  const {
    control,
    formState: { errors },
    watch
  } = useForm({
    defaultValues: { reference_date: dayjs(date).toDate() },
    resolver: yupResolver(referenceDateSchema),
    mode: 'onChange'
  });
  const [referenceDate, setReferenceDate] = useState(initialDate);
  const { data: initialRows, isFetching } = useGetCostCenterSortorder(
    costCenterId,
    referenceDate
  );

  const [rows, setRows] = useState(initialRows || []);
  const formData = watch('reference_date');

  // Update rows whenever new data comes in from the endpoint
  useEffect(() => {
    if (initialRows) {
      const uniqueRows = Array.from(
        new Map(initialRows.map((item) => [item.benefit_id, item])).values()
      );
      setRows(uniqueRows);
    }
  }, [initialRows]);

  // Effect to update the reference date
  useEffect(() => {
    if (dayjs(formData).isValid()) {
      const updatedDate = dayjs(formData).startOf('day').toISOString();
      if (updatedDate !== referenceDate) {
        setReferenceDate(updatedDate);
      }
    }
  }, [formData, referenceDate]);

  const columns = useGetColumns(rows, setRows, costCenterId);

  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box maxWidth={200} marginTop={1}>
        <ControlledDatePicker
          fullWidth
          variant="outlined"
          control={control}
          name="reference_date"
          label={t('costCenters.filters.referenceDate')}
          error={!!errors.reference_date}
          helperText={errors.reference_date?.message}
        />
      </Box>
      <Box width={1}>
        <TableCRUDLayout
          rows={rows || []}
          getRowId={(row) => row.benefit_id}
          columns={columns}
          loading={isFetching}
          pageSize={25}
          autoHeight={true}
          editable={false}
          disableActions={true}
          FormComponent={() => null}
        />
      </Box>
    </Box>
  );
};

export default FormationAndSortorder;
